import { Component, OnInit, AfterViewInit, ViewChildren } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { HelpService } from "../help-service";

@Component({
  selector: "app-panduan",
  templateUrl: "./panduan.component.html",
  styleUrls: ["./panduan.component.css"],
})
export class PanduanComponent implements OnInit {
  public isCollapsed = false;
  public show:boolean = false;
  public iconName:any = 'Show';

      
  public isShowDiv:boolean = false;
  public isShowUnduhUser:boolean = false;
  public isShowPassword:boolean = false;
  public isShowGantiPassword:boolean = false;
  public isShowCaraPesanan:boolean = false;
  public isShowOrderList:boolean = false;
  public isShowStatusItem:boolean = false;
  public isShowStatusPesanan:boolean = false;
  public isShowTrackOrder: boolean = false;
  public isShowKomuditi: boolean = false;

  toggleDisplayDiv() {
    this.isShowDiv = !this.isShowDiv;
    if(this.isShowDiv)  
    this.iconName = "Hide";
    else
    this.iconName = "Show";
  }

  toggleDisplayUnduhUser() {
    this.isShowUnduhUser = !this.isShowUnduhUser;

    // CHANGE THE NAME OF THE BUTTON.
    if(this.isShowUnduhUser)  
      this.iconName = "Hide";
    else
      this.iconName = "Show";
  }

  toggleDisplayCaraPesanan() {
    this.isShowPassword = !this.isShowPassword;
    if(this.isShowPassword)  
    this.iconName = "Hide";
    else
    this.iconName = "Show";

  }

  toggleDisplayOrderList() {
    this.isShowOrderList = !this.isShowOrderList;
    if(this.isShowOrderList)  
    this.iconName = "Hide";
    else
    this.iconName = "Show";

  }

  toggleDisplayLupaPassword() {
    this.isShowPassword = !this.isShowPassword;
    if(this.isShowPassword)  
    this.iconName = "Hide";
    else
    this.iconName = "Show";

  }

  toggleDisplayGantiPassword() {
    this.isShowGantiPassword = !this.isShowGantiPassword;
    if(this.isShowGantiPassword)  
    this.iconName = "Hide";
    else
    this.iconName = "Show";

  }

  toggleDisplayTrackOrder() {
    this.isShowTrackOrder = !this.isShowTrackOrder;
    if(this.isShowTrackOrder)  
    this.iconName = "Hide";
    else
    this.iconName = "Show";

  }

  toggleDisplayPesanKomuditi() {
    this.isShowKomuditi = !this.isShowKomuditi;
    if(this.isShowKomuditi)  
    this.iconName = "Hide";
    else
    this.iconName = "Show";

  }

  toggleDisplayStatusItem() {
    this.isShowStatusItem = !this.isShowStatusItem;
    if(this.isShowStatusItem)  
    this.iconName = "Hide";
    else
    this.iconName = "Show";

  }

  toggleDisplayStatusPesanan() {
    this.isShowStatusPesanan = !this.isShowStatusPesanan;
    if(this.isShowStatusPesanan)  
    this.iconName = "Hide";
    else
    this.iconName = "Show";

  }
  
  constructor(
    private helpService: HelpService,
    public fb: FormBuilder,
    private toastr: ToastrService,
  ) {}


  panduanForm = this.fb.group({
    pic: ["", Validators.required],
    email: ["", [Validators.required, Validators.email]],
    name: ["", Validators.required],
    phonenumber: [
      "",
      [
        Validators.required,
        Validators.pattern("^((\\+62-?)|0)?[- +()0-9]+"),
        Validators.minLength(10),
        Validators.maxLength(15),
      ],
    ],
    soldto: ["", Validators.required],
    nik: [
      "",
      Validators.required,
      Validators.minLength(15),
      Validators.maxLength(16),
    ],
    address: ["", Validators.required],
    city: ["", Validators.required],
  });

  ngOnInit(): void {}

  get f() {
    return this.panduanForm.controls;
  }

  submitForm() {}
}
